/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getIndustryMaster = /* GraphQL */ `query GetIndustryMaster($id: ID!) {
    getIndustryMaster(id: $id) {
      id
      startDateTime
      endDateTime
      mainCategory
      subCategory
      item
      itemFlg
      scaleCode
      industryName
      searchName
      stringSearchName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.GetIndustryMasterQueryVariables,
  APITypes.GetIndustryMasterQuery
>;
export const listIndustryMasters = /* GraphQL */ `query ListIndustryMasters(
    $filter: ModelIndustryMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIndustryMasters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        startDateTime
        endDateTime
        mainCategory
        subCategory
        item
        itemFlg
        scaleCode
        industryName
        searchName
        stringSearchName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.ListIndustryMastersQueryVariables,
  APITypes.ListIndustryMastersQuery
>;
export const syncIndustryMasters = /* GraphQL */ `query SyncIndustryMasters(
    $filter: ModelIndustryMasterFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncIndustryMasters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        startDateTime
        endDateTime
        mainCategory
        subCategory
        item
        itemFlg
        scaleCode
        industryName
        searchName
        stringSearchName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.SyncIndustryMastersQueryVariables,
  APITypes.SyncIndustryMastersQuery
>;
export const industryMastersByMainCategory = /* GraphQL */ `query IndustryMastersByMainCategory(
    $mainCategory: String!
    $sortDirection: ModelSortDirection
    $filter: ModelIndustryMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    industryMastersByMainCategory(
      mainCategory: $mainCategory
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        startDateTime
        endDateTime
        mainCategory
        subCategory
        item
        itemFlg
        scaleCode
        industryName
        searchName
        stringSearchName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.IndustryMastersByMainCategoryQueryVariables,
  APITypes.IndustryMastersByMainCategoryQuery
>;
export const industryMastersBySubCategory = /* GraphQL */ `query IndustryMastersBySubCategory(
    $subCategory: String!
    $sortDirection: ModelSortDirection
    $filter: ModelIndustryMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    industryMastersBySubCategory(
      subCategory: $subCategory
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        startDateTime
        endDateTime
        mainCategory
        subCategory
        item
        itemFlg
        scaleCode
        industryName
        searchName
        stringSearchName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.IndustryMastersBySubCategoryQueryVariables,
  APITypes.IndustryMastersBySubCategoryQuery
>;
export const industryMastersByItem = /* GraphQL */ `query IndustryMastersByItem(
    $item: String!
    $sortDirection: ModelSortDirection
    $filter: ModelIndustryMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    industryMastersByItem(
      item: $item
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        startDateTime
        endDateTime
        mainCategory
        subCategory
        item
        itemFlg
        scaleCode
        industryName
        searchName
        stringSearchName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.IndustryMastersByItemQueryVariables,
  APITypes.IndustryMastersByItemQuery
>;
export const industryMastersByItemFlg = /* GraphQL */ `query IndustryMastersByItemFlg(
    $itemFlg: String!
    $sortDirection: ModelSortDirection
    $filter: ModelIndustryMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    industryMastersByItemFlg(
      itemFlg: $itemFlg
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        startDateTime
        endDateTime
        mainCategory
        subCategory
        item
        itemFlg
        scaleCode
        industryName
        searchName
        stringSearchName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.IndustryMastersByItemFlgQueryVariables,
  APITypes.IndustryMastersByItemFlgQuery
>;
export const getFinancialAnalysisMaster = /* GraphQL */ `query GetFinancialAnalysisMaster($id: ID!) {
    getFinancialAnalysisMaster(id: $id) {
      id
      classification
      mainCategory
      subCategory
      item
      scaleCode
      surplus
      industryCode
      yearEdition
      NoTC
      ANoE
      DR
      ER
      CR
      QR
      FAtER
      FAtLTCR
      IBDR
      ARtAPR
      CIPEtARR
      CATR
      CATD
      ARTR
      ARTD
      CDTR
      CDTD
      ITR
      ITD
      STR
      STD
      WIPTR
      WIPTD
      CIPTR
      CIPTD
      RMSTR
      RMSTD
      FATR
      FATD
      TFATR
      TFATD
      OITR
      OITD
      TATR
      TATD
      LTR
      LTD
      APTR
      APTD
      IBDTR
      IBDTD
      CIPRTR
      CIPRTD
      STBTR
      STBTD
      ETR
      ETD
      GPM
      OPM
      RPM
      PTPM
      NPM
      ORtTAR
      PTPtTAR
      NPtTAR
      RoE
      OPtOAR
      CoSR
      SGAEtSR
      IBtNSR
      IRoIBD
      SGR
      OPGR
      TAGR
      EGR
      MSpE
      MOEpE
      MGVApE
      MOPpE
      LER
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.GetFinancialAnalysisMasterQueryVariables,
  APITypes.GetFinancialAnalysisMasterQuery
>;
export const listFinancialAnalysisMasters = /* GraphQL */ `query ListFinancialAnalysisMasters(
    $filter: ModelFinancialAnalysisMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFinancialAnalysisMasters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        classification
        mainCategory
        subCategory
        item
        scaleCode
        surplus
        industryCode
        yearEdition
        NoTC
        ANoE
        DR
        ER
        CR
        QR
        FAtER
        FAtLTCR
        IBDR
        ARtAPR
        CIPEtARR
        CATR
        CATD
        ARTR
        ARTD
        CDTR
        CDTD
        ITR
        ITD
        STR
        STD
        WIPTR
        WIPTD
        CIPTR
        CIPTD
        RMSTR
        RMSTD
        FATR
        FATD
        TFATR
        TFATD
        OITR
        OITD
        TATR
        TATD
        LTR
        LTD
        APTR
        APTD
        IBDTR
        IBDTD
        CIPRTR
        CIPRTD
        STBTR
        STBTD
        ETR
        ETD
        GPM
        OPM
        RPM
        PTPM
        NPM
        ORtTAR
        PTPtTAR
        NPtTAR
        RoE
        OPtOAR
        CoSR
        SGAEtSR
        IBtNSR
        IRoIBD
        SGR
        OPGR
        TAGR
        EGR
        MSpE
        MOEpE
        MGVApE
        MOPpE
        LER
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.ListFinancialAnalysisMastersQueryVariables,
  APITypes.ListFinancialAnalysisMastersQuery
>;
export const syncFinancialAnalysisMasters = /* GraphQL */ `query SyncFinancialAnalysisMasters(
    $filter: ModelFinancialAnalysisMasterFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncFinancialAnalysisMasters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        classification
        mainCategory
        subCategory
        item
        scaleCode
        surplus
        industryCode
        yearEdition
        NoTC
        ANoE
        DR
        ER
        CR
        QR
        FAtER
        FAtLTCR
        IBDR
        ARtAPR
        CIPEtARR
        CATR
        CATD
        ARTR
        ARTD
        CDTR
        CDTD
        ITR
        ITD
        STR
        STD
        WIPTR
        WIPTD
        CIPTR
        CIPTD
        RMSTR
        RMSTD
        FATR
        FATD
        TFATR
        TFATD
        OITR
        OITD
        TATR
        TATD
        LTR
        LTD
        APTR
        APTD
        IBDTR
        IBDTD
        CIPRTR
        CIPRTD
        STBTR
        STBTD
        ETR
        ETD
        GPM
        OPM
        RPM
        PTPM
        NPM
        ORtTAR
        PTPtTAR
        NPtTAR
        RoE
        OPtOAR
        CoSR
        SGAEtSR
        IBtNSR
        IRoIBD
        SGR
        OPGR
        TAGR
        EGR
        MSpE
        MOEpE
        MGVApE
        MOPpE
        LER
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.SyncFinancialAnalysisMastersQueryVariables,
  APITypes.SyncFinancialAnalysisMastersQuery
>;
export const financialAnalysisMastersByMainCategory = /* GraphQL */ `query FinancialAnalysisMastersByMainCategory(
    $mainCategory: String!
    $sortDirection: ModelSortDirection
    $filter: ModelFinancialAnalysisMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    financialAnalysisMastersByMainCategory(
      mainCategory: $mainCategory
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        classification
        mainCategory
        subCategory
        item
        scaleCode
        surplus
        industryCode
        yearEdition
        NoTC
        ANoE
        DR
        ER
        CR
        QR
        FAtER
        FAtLTCR
        IBDR
        ARtAPR
        CIPEtARR
        CATR
        CATD
        ARTR
        ARTD
        CDTR
        CDTD
        ITR
        ITD
        STR
        STD
        WIPTR
        WIPTD
        CIPTR
        CIPTD
        RMSTR
        RMSTD
        FATR
        FATD
        TFATR
        TFATD
        OITR
        OITD
        TATR
        TATD
        LTR
        LTD
        APTR
        APTD
        IBDTR
        IBDTD
        CIPRTR
        CIPRTD
        STBTR
        STBTD
        ETR
        ETD
        GPM
        OPM
        RPM
        PTPM
        NPM
        ORtTAR
        PTPtTAR
        NPtTAR
        RoE
        OPtOAR
        CoSR
        SGAEtSR
        IBtNSR
        IRoIBD
        SGR
        OPGR
        TAGR
        EGR
        MSpE
        MOEpE
        MGVApE
        MOPpE
        LER
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.FinancialAnalysisMastersByMainCategoryQueryVariables,
  APITypes.FinancialAnalysisMastersByMainCategoryQuery
>;
export const financialAnalysisMastersByYearEdition = /* GraphQL */ `query FinancialAnalysisMastersByYearEdition(
    $yearEdition: String!
    $sortDirection: ModelSortDirection
    $filter: ModelFinancialAnalysisMasterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    financialAnalysisMastersByYearEdition(
      yearEdition: $yearEdition
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        classification
        mainCategory
        subCategory
        item
        scaleCode
        surplus
        industryCode
        yearEdition
        NoTC
        ANoE
        DR
        ER
        CR
        QR
        FAtER
        FAtLTCR
        IBDR
        ARtAPR
        CIPEtARR
        CATR
        CATD
        ARTR
        ARTD
        CDTR
        CDTD
        ITR
        ITD
        STR
        STD
        WIPTR
        WIPTD
        CIPTR
        CIPTD
        RMSTR
        RMSTD
        FATR
        FATD
        TFATR
        TFATD
        OITR
        OITD
        TATR
        TATD
        LTR
        LTD
        APTR
        APTD
        IBDTR
        IBDTD
        CIPRTR
        CIPRTD
        STBTR
        STBTD
        ETR
        ETD
        GPM
        OPM
        RPM
        PTPM
        NPM
        ORtTAR
        PTPtTAR
        NPtTAR
        RoE
        OPtOAR
        CoSR
        SGAEtSR
        IBtNSR
        IRoIBD
        SGR
        OPGR
        TAGR
        EGR
        MSpE
        MOEpE
        MGVApE
        MOPpE
        LER
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.FinancialAnalysisMastersByYearEditionQueryVariables,
  APITypes.FinancialAnalysisMastersByYearEditionQuery
>;
export const getPublicManagementIndicators = /* GraphQL */ `query GetPublicManagementIndicators($id: ID!) {
    getPublicManagementIndicators(id: $id) {
      id
      usingStartDate
      usingEndDate
      yearEdition
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.GetPublicManagementIndicatorsQueryVariables,
  APITypes.GetPublicManagementIndicatorsQuery
>;
export const listPublicManagementIndicators = /* GraphQL */ `query ListPublicManagementIndicators(
    $filter: ModelPublicManagementIndicatorsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPublicManagementIndicators(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usingStartDate
        usingEndDate
        yearEdition
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.ListPublicManagementIndicatorsQueryVariables,
  APITypes.ListPublicManagementIndicatorsQuery
>;
export const syncPublicManagementIndicators = /* GraphQL */ `query SyncPublicManagementIndicators(
    $filter: ModelPublicManagementIndicatorsFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPublicManagementIndicators(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        usingStartDate
        usingEndDate
        yearEdition
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.SyncPublicManagementIndicatorsQueryVariables,
  APITypes.SyncPublicManagementIndicatorsQuery
>;
export const publicManagementIndicatorsByYearEdition = /* GraphQL */ `query PublicManagementIndicatorsByYearEdition(
    $yearEdition: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPublicManagementIndicatorsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    publicManagementIndicatorsByYearEdition(
      yearEdition: $yearEdition
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usingStartDate
        usingEndDate
        yearEdition
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.PublicManagementIndicatorsByYearEditionQueryVariables,
  APITypes.PublicManagementIndicatorsByYearEditionQuery
>;
export const getInputDataSave = /* GraphQL */ `query GetInputDataSave($id: ID!) {
    getInputDataSave(id: $id) {
      id
      mailAddress
      userId
      conditionsName
      financialAnalysisData
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.GetInputDataSaveQueryVariables,
  APITypes.GetInputDataSaveQuery
>;
export const listInputDataSaves = /* GraphQL */ `query ListInputDataSaves(
    $filter: ModelInputDataSaveFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInputDataSaves(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mailAddress
        userId
        conditionsName
        financialAnalysisData
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.ListInputDataSavesQueryVariables,
  APITypes.ListInputDataSavesQuery
>;
export const syncInputDataSaves = /* GraphQL */ `query SyncInputDataSaves(
    $filter: ModelInputDataSaveFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncInputDataSaves(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        mailAddress
        userId
        conditionsName
        financialAnalysisData
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.SyncInputDataSavesQueryVariables,
  APITypes.SyncInputDataSavesQuery
>;
export const inputDataSavesByMailAddressAndConditionsName = /* GraphQL */ `query InputDataSavesByMailAddressAndConditionsName(
    $mailAddress: String!
    $conditionsName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInputDataSaveFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inputDataSavesByMailAddressAndConditionsName(
      mailAddress: $mailAddress
      conditionsName: $conditionsName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mailAddress
        userId
        conditionsName
        financialAnalysisData
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.InputDataSavesByMailAddressAndConditionsNameQueryVariables,
  APITypes.InputDataSavesByMailAddressAndConditionsNameQuery
>;
export const getContractInfo = /* GraphQL */ `query GetContractInfo($id: ID!) {
    getContractInfo(id: $id) {
      id
      systemId
      detailsManagementNo
      mailAddress
      userId
      identityId
      custCode
      custName
      managerCode
      orderDate
      usingStartDate
      usingEndDate
      yearEdition
      mailFrom
      mailNotice
      mailNoticeCc
      productCode
      productName
      usingStartMailFlg
      usingEndMailFlg
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.GetContractInfoQueryVariables,
  APITypes.GetContractInfoQuery
>;
export const listContractInfos = /* GraphQL */ `query ListContractInfos(
    $filter: ModelContractInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContractInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        systemId
        detailsManagementNo
        mailAddress
        userId
        identityId
        custCode
        custName
        managerCode
        orderDate
        usingStartDate
        usingEndDate
        yearEdition
        mailFrom
        mailNotice
        mailNoticeCc
        productCode
        productName
        usingStartMailFlg
        usingEndMailFlg
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.ListContractInfosQueryVariables,
  APITypes.ListContractInfosQuery
>;
export const syncContractInfos = /* GraphQL */ `query SyncContractInfos(
    $filter: ModelContractInfoFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncContractInfos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        systemId
        detailsManagementNo
        mailAddress
        userId
        identityId
        custCode
        custName
        managerCode
        orderDate
        usingStartDate
        usingEndDate
        yearEdition
        mailFrom
        mailNotice
        mailNoticeCc
        productCode
        productName
        usingStartMailFlg
        usingEndMailFlg
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.SyncContractInfosQueryVariables,
  APITypes.SyncContractInfosQuery
>;
export const contractInfosByDetailsManagementNo = /* GraphQL */ `query ContractInfosByDetailsManagementNo(
    $detailsManagementNo: String!
    $sortDirection: ModelSortDirection
    $filter: ModelContractInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contractInfosByDetailsManagementNo(
      detailsManagementNo: $detailsManagementNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        systemId
        detailsManagementNo
        mailAddress
        userId
        identityId
        custCode
        custName
        managerCode
        orderDate
        usingStartDate
        usingEndDate
        yearEdition
        mailFrom
        mailNotice
        mailNoticeCc
        productCode
        productName
        usingStartMailFlg
        usingEndMailFlg
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.ContractInfosByDetailsManagementNoQueryVariables,
  APITypes.ContractInfosByDetailsManagementNoQuery
>;
export const contractInfosByMailAddress = /* GraphQL */ `query ContractInfosByMailAddress(
    $mailAddress: String!
    $sortDirection: ModelSortDirection
    $filter: ModelContractInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contractInfosByMailAddress(
      mailAddress: $mailAddress
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        systemId
        detailsManagementNo
        mailAddress
        userId
        identityId
        custCode
        custName
        managerCode
        orderDate
        usingStartDate
        usingEndDate
        yearEdition
        mailFrom
        mailNotice
        mailNoticeCc
        productCode
        productName
        usingStartMailFlg
        usingEndMailFlg
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.ContractInfosByMailAddressQueryVariables,
  APITypes.ContractInfosByMailAddressQuery
>;
export const contractInfosByUsingStartDate = /* GraphQL */ `query ContractInfosByUsingStartDate(
    $usingStartDate: String!
    $sortDirection: ModelSortDirection
    $filter: ModelContractInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contractInfosByUsingStartDate(
      usingStartDate: $usingStartDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        systemId
        detailsManagementNo
        mailAddress
        userId
        identityId
        custCode
        custName
        managerCode
        orderDate
        usingStartDate
        usingEndDate
        yearEdition
        mailFrom
        mailNotice
        mailNoticeCc
        productCode
        productName
        usingStartMailFlg
        usingEndMailFlg
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.ContractInfosByUsingStartDateQueryVariables,
  APITypes.ContractInfosByUsingStartDateQuery
>;
export const contractInfosByUsingEndDate = /* GraphQL */ `query ContractInfosByUsingEndDate(
    $usingEndDate: String!
    $sortDirection: ModelSortDirection
    $filter: ModelContractInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contractInfosByUsingEndDate(
      usingEndDate: $usingEndDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        systemId
        detailsManagementNo
        mailAddress
        userId
        identityId
        custCode
        custName
        managerCode
        orderDate
        usingStartDate
        usingEndDate
        yearEdition
        mailFrom
        mailNotice
        mailNoticeCc
        productCode
        productName
        usingStartMailFlg
        usingEndMailFlg
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const contractInfosByUsingStartMailFlgAndUsingStartDate = /* GraphQL */ `
  query ContractInfosByUsingStartMailFlgAndUsingStartDate(
    $usingStartMailFlg: String!
    $usingStartDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelContractInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contractInfosByUsingStartMailFlgAndUsingStartDate(
      usingStartMailFlg: $usingStartMailFlg
      usingStartDate: $usingStartDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        systemId
        detailsManagementNo
        mailAddress
        userId
        identityId
        custCode
        custName
        managerCode
        orderDate
        usingStartDate
        usingEndDate
        yearEdition
        mailFrom
        mailNotice
        mailNoticeCc
        productCode
        productName
        usingStartMailFlg
        usingEndMailFlg
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getLoginInfo = /* GraphQL */ `
  query GetLoginInfo($id: ID!) {
    getLoginInfo(id: $id) {
      id
      userId
      sessionId
      expireDateTime
      expireDateTimeUnix
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.GetLoginInfoQueryVariables,
  APITypes.GetLoginInfoQuery
>;
export const listLoginInfos = /* GraphQL */ `query ListLoginInfos(
    $filter: ModelLoginInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLoginInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        sessionId
        expireDateTime
        expireDateTimeUnix
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.ListLoginInfosQueryVariables,
  APITypes.ListLoginInfosQuery
>;
export const syncLoginInfos = /* GraphQL */ `query SyncLoginInfos(
    $filter: ModelLoginInfoFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncLoginInfos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        userId
        sessionId
        expireDateTime
        expireDateTimeUnix
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.SyncLoginInfosQueryVariables,
  APITypes.SyncLoginInfosQuery
>;
export const loginInfosByUserId = /* GraphQL */ `query LoginInfosByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelLoginInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    loginInfosByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        sessionId
        expireDateTime
        expireDateTimeUnix
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.LoginInfosByUserIdQueryVariables,
  APITypes.LoginInfosByUserIdQuery
>;
